export default class UrlParameterEncoder {
  constructor(object: any, prefix: any) {
    // @ts-ignore
    this.object = object;
    // @ts-ignore
    this.prefix = prefix;
  }

  // @ts-ignore
  serialize(obj: any, prefix: any, noEnCode: any) {
    let str = [];
    for (let p in obj) {
      if (obj.hasOwnProperty(p)) {
        let k = prefix ? prefix + "[" + p + "]" : p,
          v = obj[p];
        let vValue = noEnCode ? v : encodeURIComponent(v);
        str.push(
          v !== null && typeof v === "object"
            ? // @ts-ignore
              this.serialize(v, k)
            : encodeURIComponent(k) + "=" + vValue
        );
      }
    }

    return str.join("&");
  }

  getQueryString() {
    // @ts-ignore
    return this.serialize(this.object, this.prefix, false);
  }

  getNotEncodeQueryString() {
    // @ts-ignore
    return this.serialize(this.object, this.prefix, true);
  }
}
